<template>
  <div class="row items-start q-pl-sm" @click.stop @keyup.stop>
    <section
      class="address-input-item"
      v-for="item in necessaryLevels"
      :key="item.key"
    >
      <q-select
        dense
        :menu-offset="[0, 5]"
        filled
        @click.stop
        @keyup.stop
        style="min-width: 250px"
        :label="
          !options[item.key] || !options[item.key].length
            ? `请先选择上一级`
            : `请选择${item.label}`
        "
        :value="(value || {})[item.key]"
        @input="
          (value) => {
            handleCommonError(item.key, value);
            handleInput(item.key, value);
          }
        "
        :options="options[item.key]"
        option-label="name"
        option-value="code"
        options-dense
        :popup-content-class="`rounded-borders shadow-1`"
        :disable="!options[item.key] && !options[item.key].length"
        :error="!!selectCommonError"
        :error-message="selectCommonError"
      />
      <span style="white-space: nowrap; line-height: 40px">
        {{ item.label }}
      </span>
    </section>

    <section
      v-if="conf && conf.config && conf.config.address_plus"
      class="address-input-item"
    >
      <q-input
        dense
        filled
        style="min-width: 250px"
        :type="addressPlusInputType"
        :label="`请输入${conf.config.address_plus.label}`"
        :value="(value || {}).plus"
        @input="
          (v) =>
            $emit('change', {
              ...value,
              plus: v,
            })
        "
      />
      <span style="white-space: nowrap; line-height: 40px">
        {{ conf.config.address_plus.label }}
      </span>
    </section>
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";

import provinces from "@/libs/area-info/provinces";
import cities from "@/libs/area-info/cities";
import counties from "@/libs/area-info/counties";
import towns from "@/libs/area-info/towns";

export default {
  mixins: [QuestionChoiceMixin],
  data() {
    return {
      levels: [
        { key: "province", label: "省" },
        { key: "city", label: "市" },
        { key: "county", label: "区/县" },
        { key: "street", label: "街道" },
      ],

      selectCommonError: "",
    };
  },

  computed: {
    config() {
      return (this.conf || {}).config || {};
    },

    necessaryLevels() {
      return this.levels.filter((l) => this.config[l.key]);
    },

    options() {
      const { province, city, county, street } = this.value || {};
      const enable_prov = this.config.province;
      const enable_city = this.config.city;
      const enable_coun = this.config.county;
      const enable_stre = this.config.street;

      const options = {
        province: provinces,
        city:
          province && province.code
            ? cities.filter(({ parent }) => parent === province.code)
            : enable_prov
            ? []
            : cities,
        county:
          city && city.code
            ? counties.filter(({ parent }) => parent === city.code)
            : [],
        street:
          county && county.code
            ? towns.filter(({ parent }) => parent === county.code)
            : [],
      };
      return options;
    },

    addressPlusInputType() {
      const { conf } = this;
      let t = (((conf || {}).config || {}).address_plus || {}).input_type;
      if (!t) t = "text";
      else if (t !== "text") t = "number";
      return t;
    },

    errorTextDict() {
      const { selectCommonError } = this;
      return {
        selectCommonError,
      };
    },
  },

  watch: {
    checked(ckd) {
      if (ckd) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.handleCommonError();
          });
        }, 0);
      }
    },
    conf: {
      immediate: true,
      handler(conf) {
        if (conf && !conf.config.province) {
          // 未配置省，默认选择浙江
          if (!this.value || !this.value.province) {
            this.$emit("change", {
              ...(this.value || {}),
              province: provinces.find((p) => p.code === 330000),
            });
          }
        }
      },
    },
  },

  methods: {
    /**
     * 处理输入
     */
    handleInput(key, value) {
      const newValue = {
        ...this.value,
        [key]: value,
      };
      if (key === "province" || key === "city" || key === "county") {
        // 删除街道
        newValue.street = null;
      }
      if (key === "province" || key === "city") {
        newValue.street = null;
        newValue.county = null;
      }
      if (key === "province") {
        newValue.street = null;
        newValue.county = null;
        newValue.city = null;
      }
      this.$emit("change", newValue);
    },

    handleCommonError(key, value) {
      if (!this.checked) {
        this.selectCommonError = "当前选项未选中，选择将不生效";
      } else {
        this.selectCommonError = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address-input-item {
  display: flex;
  align-items: flex-start;
  margin-right: 10px;

  margin-bottom: 5px;
  & > span {
    margin-left: 10px;
  }
}
</style>
